




































import { Component, Vue, Prop } from 'vue-property-decorator';
import vueSignature from 'vue-signature';
import { api } from '../api';


@Component({
  components: { vueSignature }
})
export default class SignatureDialog extends Vue {
  @Prop(String) public readonly title!: string;
  @Prop(String) public readonly url!: string;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  public api = api;
  public dialog = false;
  public defaultUrl: string = '';
  public sigIsEmpty = true;

  public async open_dialog() {
    if (this.url) {
      this.defaultUrl = await this.api.getFileURL(this.$store, this.url);
      this.dialog = true;
    }
  }

  public do_clear() {
    const ref: any = this.$refs.signature;
    ref.clear();
  }
  public setEmpty(v: boolean) {
    this.sigIsEmpty = v;
  }


  public async do_save() {
    const ref: any = this.$refs.signature;
    // console.log(this.url);
    if (this.url) {
      if (ref.isEmpty()) {
        const result = await this.api.deleteFile(this.$store, this.url);
        this.sigIsEmpty = true;
      } else {
        const jpeg = ref.save('image/jpeg');
        // console.log('jpeg', jpeg.length);

        const formData = new FormData();
        const file: Blob = this.dataURLtoBlob(jpeg);
        formData.append('file', file, 'signature.jpg');
        const result = await this.api.uploadFile(this.$store, this.url, formData);
        this.sigIsEmpty = false;
        // console.log('saved', result);
      }
      this.$emit('change', this);
    }
    this.dialog = false;
  }


  public dataURLtoBlob(dataurl) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type: mime});
  }
}
